import { Modal } from "react-bootstrap";
import ErrorHandler from "../../common/ErrorHandler";
import UserIcon from "../../img/user-icon.png";
import {
  formatDateDDMMYYYY,
  getTime,
} from "../../helpers/functions/dateFormatter";

function ViewRemarksModal(props) {
  const { user, data, loading } = props;

  try {
    return (
      <>
        <Modal
          {...props}
          size="lg"
          backdrop="static"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          scrollable
        >
          <Modal.Header closeButton>
            <div>
              <h5 className="m-0 p-0">{user.name} - Follow-Ups History</h5>
            </div>
          </Modal.Header>
          <Modal.Body style={{ maxHeight: "400px", overflow: "auto" }}>
            {loading ? (
              <div
                className="align-content-center text-center text-secondary"
                style={{ height: "100px" }}
              >
                Loading...
              </div>
            ) : (
              <>
                {data.length === 0 ? (
                  <div
                    className="align-content-center text-center"
                    style={{ height: "100px" }}
                  >
                    No Follow-Ups yet!
                  </div>
                ) : (
                  <>
                    {data?.map((comment, index) => (
                      <div
                        className="border mb-3 p-2"
                        style={{ borderRadius: "4px" }}
                        key={index}
                      >
                        <div className=" d-flex justify-content-start align-items-start">
                          <img
                            src={UserIcon}
                            alt="user"
                            className="rounded-circle me-2"
                            style={{ width: "2rem", height: "auto" }}
                          />

                          <div className=" flex-grow-1">
                            <div className=" d-flex justify-content-between align-items-center mb-2">
                              <span className=" fs-6 me-2 flex-grow-1">
                                {comment?.created_by ? comment?.created_by : ""}
                              </span>

                              <div className="d-flex justify-content-start align-items-center text-secondary mb-1">
                                <i
                                  className="bi bi-calendar4 me-1"
                                  style={{ fontSize: "12px" }}
                                ></i>
                                <p
                                  className="m-0 p-0 me-2"
                                  style={{ fontSize: "12px" }}
                                >
                                  {formatDateDDMMYYYY(
                                    new Date(comment.created_at)
                                  )}
                                </p>
                                <i
                                  className="bi bi-clock me-1"
                                  style={{ fontSize: "12px" }}
                                ></i>
                                <p
                                  className="m-0 p-0 me-2"
                                  style={{ fontSize: "12px" }}
                                >
                                  {getTime(new Date(comment.created_at))}
                                </p>
                              </div>
                            </div>

                            <p
                              className="m-0 p-0 text-capitalize text-left"
                              style={{ fontSize: "14px" }}
                            >
                              {comment?.comment}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                )}
              </>
            )}
          </Modal.Body>
        </Modal>
      </>
    );
  } catch (error) {
    return <ErrorHandler error={error} />;
  }
}

export default ViewRemarksModal;
